import { Flex } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { Text } from "ui/Typography"
import { spacings } from "themes/variables"
import styles from "./InfoBox.module.css"

/**
 * Muted surface box with a leading info icon — the "Info box" component used across
 * the listing wizard for inline hints (pricing adjustments, booking options, duration type).
 */
export const InfoBox = ({ children, className }) => (
  <Flex align="flex-start" gap={spacings.XS} className={[styles.box, className].filter(Boolean).join(" ")}>
    <InfoCircleOutlined className={styles.icon} />
    <Text className={styles.text}>{children}</Text>
  </Flex>
)

InfoBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
